import { tagColors } from '@/components/tag/tag-colors'
export const areCasesRequiredOptions = [{id: 0, text: '混装'}, {id: 1, text: '原厂包装'}]
export const operateOptions = {
    open: [
        {id: 'edit', text: '编辑'},
        {id: 'pushReview', text: '提审'},
        {id: 'pass', text: '审核通过'},
        {id: 'reject', text: '审核驳回'},
        {id: 'copy', text: '复制'},
        {id: 'complete', text: '标记完成'},
        {id: 'invalid', text: '作废'},
        {id: 'del', text: '删除'}],
    close:[
        {id: 'edit', text: '编辑'},
        {id: 'copy', text: '复制'},
        {id: 'complete', text: '标记完成'},
        {id: 'invalid', text: '作废'},
    ]
}
// 下拉列表状态
export const statusOption = {
    open: [
        {id: 'processing', text: '进行中', ...tagColors.orange},
        { id: 'draft', text: '草稿', ...tagColors.blue},
        { id: 'waitReview', text: '待审核', ...tagColors.orange},
        { id: 'rejected', text: '已驳回', ...tagColors.red},
        { id: 'waitHandle', text: '待处理', ...tagColors.orange},
        { id: 'processed', text: '已处理', ...tagColors.green},
        { id: 'abolished', text: '已作废', ...tagColors.lightGray},
    ],
    close:[
        {id: 'processing', text: '进行中', color: '#1F6EEF'},
        {id: 'waitHandle', text: '待处理', color: '#F98F04'},
        {id: 'processed', text: '已处理', color: '#CCCCCC'},
        {id: 'abolished', text: '已作废', color: '#E7EAEF'},
    ]
}
export const statusEnum = {
    DRAFT: 'draft',
    WAIT_REVIEW: 'waitReview',  // 待审批
    REJECTED: 'rejected',
    WAIT_HANDLE: 'waitHandle',   // 待处理
    PROCESSED: 'processed',
    ABOLISHED: 'abolished'
}
